import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';
import WATCH_TYPE_LIST from '../../config/watch-types.config';

const WatchTypes = ({
  id,
  name,
  label,
  defaultValue,
  multiple,
  disabled,
  onChange,
  sx,
  error,
}) => {
  const selectedValue = defaultValue || (multiple ? [] : null);
  const options = WATCH_TYPE_LIST;

  const [value, setValue] = useState(selectedValue);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setValue(selectedValue);
  }, [selectedValue]);

  return (
    <Autocomplete
      id={id}
      name={name}
      options={options}
      getOptionLabel={(option) => option.title}
      sx={sx}
      value={value}
      onChange={(e, v) => {
        setValue(v);
        onChange(v);
      }}
      inputValue={inputValue}
      onInputChange={(e, v) => {
        setInputValue(v);
      }}
      multiple={multiple}
      disabled={disabled}
      isOptionEqualToValue={(op, vl) => op.id === vl.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error !== ''}
          helperText={error}
          variant="filled"
        />
      )}
    />
  );
};

WatchTypes.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
};
WatchTypes.defaultProps = {
  multiple: false,
  disabled: false,
  sx: {},
  defaultValue: null,
  error: '',
};

export default WatchTypes;
